import { buildSelectionKey, isSelectableItem } from './selectionKey';

export const sliceRange = (entries, fromId, toId, getId) => {
  const start = entries.findIndex((entry) => getId(entry) === fromId);
  const end = entries.findIndex((entry) => getId(entry) === toId);

  if (start === -1 || end === -1) {
    return null;
  }

  const [from, to] = [start, end].sort((a, b) => a - b);
  return entries.slice(from, to + 1);
};

export const sliceSelectableItemsByKeys = (items, anchorKey, targetKey) => {
  const selectableItems = items.filter(isSelectableItem);
  return sliceRange(selectableItems, anchorKey, targetKey, buildSelectionKey);
};

export const getGridShiftRangeItems = (selection, items, { item, isRange }) => {
  if (!isSelectableItem(item)) {
    return null;
  }

  if (!isRange || !selection.lastClickedKey) {
    return [item];
  }

  const range = sliceSelectableItemsByKeys(
    items,
    selection.lastClickedKey,
    buildSelectionKey(item),
  );

  return range ?? [item];
};

export const resolveGridShiftRange = (items, anchorKey, targetKey) => (
  sliceSelectableItemsByKeys(items, anchorKey, targetKey)
);
